import React from 'react'
import { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';
import {  Bar } from 'react-chartjs-2';
import API from '../utils/api.js'
import { formatearNumero } from '../utils/FormatearNumero.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);


const data_inicio_donut = {
  labels: ['Sin resultados'],
  datasets: [
    {
      data: [0],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)'
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)'
      ],
      borderWidth: 1,
    },
  ],
};


const data_inicio_bar = {
  labels: ['Sin resultados'],
  datasets: [
    {
      label: 'Ganancia Neta',
      data: [0],
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};


const data_inicio_bar2 = {
  labels: ['Sin resultados'],
  datasets: [
    {
      label: 'Cantidad Prestamos',
      data: [0],
      backgroundColor:  'rgba(255, 99, 132, 0.2)',
    },
  ],
};

export default function GananciaReal(){

    var url = API.urlAPI
    const urlGananciaPrestamos = url + "prestamos/GananciaReal"
    const urlGananciaVentas = url + "prestamos/GananciaRealVentas"
    const urlGananciaPrestamosMes = url + "prestamos/GananciaRealMes"
    const urlGananciaVentasMes = url + "prestamos/GananciaRealMesVentas"

    const [dataBar, setDataBar] = useState(data_inicio_bar)
    const [dataBar2, setDataBar2] = useState(data_inicio_bar2)
    const [cantCreditos, setCantCreditos] = useState("0")
    const [gananciaCreditos, setGananciaCreditos] = useState("0")
    const [cantVentas, setCantVentas] = useState("0")
    const [gananciaVentas, setGananciVentas] = useState("0")

    const optionsBar = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          }
        }
      };

      
  
  const fetchDataBarraPrestamos = async() => {
    let resp = await fetch(urlGananciaPrestamos)
    let dataBarra = await resp.json()

  let modeloBar = {
    labels: dataBarra.map((data) => data.Mes),
    datasets: [
      {
        label: 'Ganancia por mes',
        data: dataBarra.map((data) => data.Ganancia),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ]
  };
  setDataBar(modeloBar)

  

  }

  
  const fetchDataBarraVentas = async() => {
    let resp = await fetch(urlGananciaVentas)
    let dataBarra = await resp.json()

  let modeloBar = {
    labels: dataBarra.map((data) => data.Mes),
    datasets: [
      {
        label: 'Ganancia por mes',
        data: dataBarra.map((data) => data.MontoPago),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ]
  };
  setDataBar2(modeloBar)

  

  }


  

  const fetchDataPrestamos = async() => {
    let res = await fetch(urlGananciaPrestamosMes)
    let data = await res.json()
    setCantCreditos(data.map((item) => { return item.CreditosFinalizados }))
    setGananciaCreditos(data.map((item) => { return item.Ganancia }))
  }



  const fetchDataVentas = async() => {
    let res = await fetch(urlGananciaVentasMes)
    let data = await res.json()
    setCantVentas(data.map((item) => { return item.CantCuotas }))
    setGananciVentas(data.map((item) => { return item.MontoPago }))
  }



  useEffect(() => {
    fetchDataBarraPrestamos()
    fetchDataPrestamos()
    fetchDataBarraVentas()
    fetchDataVentas()
  }, [])

    return(
        <>
              <br></br>
          <div className="row">
                
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Cantidad créditos finalizados mes actual</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">{formatearNumero(Number(cantCreditos))}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-shopping-basket fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Ganancia real créditos mes actual</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(gananciaCreditos))}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-shopping-basket fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Cantidad ventas finalizadas mes actual</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">{Number(cantVentas)}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-shopping-basket fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Ganancia real ventas mes actual</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(gananciaVentas))}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-shopping-basket fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
          </div>
          <div className="col-xl-8 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Ganancia real créditos por mes</h6>

            </div>
            <div className="card-body">
              <div style={{ height: 350 }}>
            
              <Bar options={optionsBar} data={dataBar} />
              </div>

            </div>
          </div>
        </div>
        <div className="col-xl-8 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Ganancia real ventas por mes</h6>

            </div>
            <div className="card-body " >
              <div style={{ height: 350 }}>
            
              <Bar options={optionsBar} data={dataBar2} />
              </div>

            </div>
          </div>
        </div>
        </>
    )
}